exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".status___DYOcZ {\n  border-width: 0;\n  background-color: #fafafa;\n  padding: 0;\n  text-align: right;\n  font-family: PingFangSC-Regular;\n  font-size: 12px;\n  letter-spacing: 0;\n}\n\n.img___14dcq {\n  width: 105px;\n  height: 105px;\n  margin-bottom: 1rem;\n}\n.text___2ONBD {\n  font-family: STKaitiSC-Regular;\n  font-size: 12px;\n  color: #999999;\n  letter-spacing: 0;\n}\n\n.sj___1mkQo {\n  font-family: STKaitiSC-Regular;\n  font-size: 12px;\n  color: #ae5cc9;\n  letter-spacing: 0;\n  text-align: right;\n  line-height: 17px;\n}\n\n.Button___3x2vH {\n  width: 3rem;\n  height: 1rem;\n  font-size: 0.7rem;\n  line-height: 1rem;\n  margin-top: 0.4rem;\n}\n\n.list___1hrQ1 {\n  border-top: solid 1px black;\n  width: 100%;\n  margin-top: 1rem;\n}\n", ""]);

// exports
exports.locals = {
	"status": "status___DYOcZ",
	"img": "img___14dcq",
	"text": "text___2ONBD",
	"sj": "sj___1mkQo",
	"Button": "Button___3x2vH",
	"list": "list___1hrQ1"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/css/SampleDelivery.css
// module id = 792
// module chunks = 2